module.exports = __webpack_public_path__ + "img/DSC_0759-2.fe6124a9.jpeg";